<template>
  <div class="well page">

    <div class="row">
      <img class="hidden-xs pull-right" src="/static/imgs/logo.png"/>
      <h2>Issue Marker</h2>

      <div id="showMsg"><!-- Error messages etc are shown here --></div>
      <p>
        Shown below is the floorplan for your store. Click anywhere on the floorplan to mark an issue, or click an existing issue to make changes.</p>
      <br>
    </div>

    <div id="canvasContainer" class="row">
      <svg class="" :width="floorplan.width + 'px'" :height="floorplan.height + 'px'">
        <image
            :xlink:href="floorplan.data"
            x="0"
            y="0"
            :width="floorplan.width"
            :height="floorplan.height"
            @click="floorplan_clicked"
        ></image>
        <g
            v-for="issue in issues"
            stroke-width="3"
            stroke="red"
            class="marker"
            @click="marker_clicked(issue)"
        >
          <line
              :x1="issue.loc_x - 10"
              :x2="issue.loc_x + 10"
              :y1="issue.loc_y - 10"
              :y2="issue.loc_y + 10"
          ></line>
          <line
              :x1="issue.loc_x - 10"
              :x2="issue.loc_x + 10"
              :y1="issue.loc_y + 10"
              :y2="issue.loc_y - 10"
          ></line>
          <rect
              :x="issue.loc_x - 15"
              :y="issue.loc_y - 15"
              width="30"
              height="30"
              stroke="rgba(0, 0, 0, 0)"
              fill="rgba(0, 0, 0, 0)"
          ></rect>
        </g>
      </svg>
    </div>

    <modal v-model="issue_modal_open" @hide="clear_issue">
      <span v-if="selected_issue != null && selected_issue.id != null" slot="title">Update Issue</span>
      <span v-else slot="title">New Issue</span>
      <form v-if="selected_issue != null" class="form-horizontal" enctype="multipart/form-data">
        <div class="form-group">
          <label for="show-type" class="col-lg-2 control-label">Type</label>
          <div class="col-lg-10">
            <select id="show-type" class="form-control" v-model="selected_issue.type" required>
              <option disabled></option>
              <option
                  v-for="it in issue_types"
                  :value="it.id"
              >{{ it.name }}</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="show-desc" class="col-lg-2 control-label">Description</label>
          <div class="col-lg-10">
                  <textarea id="show-desc" v-model="selected_issue.description" class="form-control"
                            placeholder="Description"></textarea>
          </div>
        </div>

        <div class="form-group">
          <label for="show-image" class="col-lg-2 control-label">File</label>
          <div class="col-lg-10">
            <input
                id="show-image"
                type="file"
                class="zUploadBtn form-control"
                placeholder="Browse..."
                accept="image/*"
                multiple
                ref="image_input"
            >
          </div>
        </div>

        <div class="form-group" v-if="selected_issue_photos.length >= 1">
          <ul>
            <li v-for="photo in selected_issue_photos" style="list-style-type: none;">
              <i class="glyphicon glyphicon-remove-sign text-danger clickable" @click="delete_photo(photo)"></i>
              {{ photo.file_name }}
            </li>
          </ul>
        </div>


        <div v-if="upload_progress.length" class="form-group progressBars">
          <progress-bar
              v-for="progress in upload_progress"
              v-model="progress.percent"
              type="success"
              :key="progress.id"
              :striped="true"
              :active="true"
          ></progress-bar>
        </div>
      </form>
      <div slot="footer">
        <button
            v-if="selected_issue != null && selected_issue.id != null"
            class="btn btn-danger"
            @click="delete_issue"
        >Delete <i class="glyphicon glyphicon-trash"></i></button>

        <button
            v-if="selected_issue != null && selected_issue.id != null"
            type="submit"
            class="btn btn-success"
            @click="update_issue"
        >Update issue <i class="glyphicon glyphicon-pencil"></i></button>

        <button
            v-else=""
            class="btn btn-success"
            @click="add_issue"
        >Add issue <i class="glyphicon glyphicon-plus"></i></button>

        <button
            class="btn btn-primary pull-left"
            @click="issue_modal_open = false"
        >Dismiss <i class="glyphicon glyphicon-remove"></i></button>
      </div>
    </modal>

    <div class="row">
      <button class="btn btn-primary pull-right" @click="urgency">Continue <i
          class="glyphicon glyphicon-share-alt"></i></button>
    </div>
  </div>
</template>

<style scoped>
  .marker {
    cursor: pointer;
  }
</style>

<script>
  import {event_to_relative, deep_copy} from "../../js/utils"

  import each from "lodash/each"
  import find from "lodash/find"
  import filter from "lodash/filter"

  import {Modal, ProgressBar} from "uiv"

  export default {
    async created () {
      let promises = [
        this.$store.dispatch("get_jobs", {job_id: this.$route.params.job_id, lazy: true}),
        this.$store.dispatch("get_issues", {job_id: this.$route.params.job_id}),
        this.$store.dispatch("get_issue_photos", {job_id: this.$route.params.job_id}),
        this.$store.dispatch("get_stores", true)
      ];
      await Promise.all(promises);
      this.$store.commit("select_job", this.$route.params.job_id);
      this.$store.commit("select_store", this.job.store);

      this.$nextTick(async () => {
        let floorplan = await (await this.$http.get(this.store.floorplan_url, {responseType: 'blob'})).blob();
        let fr = new FileReader();
        fr.onload = (event) => {
          this.floorplan.data = event.target.result;
          let img = new Image();
          img.onload = () => {
            this.floorplan.width = img.width;
            this.floorplan.height = img.height;
          };
          img.src = this.floorplan.data;
        };
        fr.readAsDataURL(floorplan);
      });
    },
    data () {
      return {
        selected_issue: null,
        issue_modal_open: false,
        uploading: false,
        floorplan: {height: 0, width: 0, data: null},
        upload_progress: []
      }
    },
    computed: {
      job () {
        return this.$store.getters.job;
      },
      issues () {
        return this.$store.getters.issues;
      },
      selected_issue_photos () {
        if (this.selected_issue !== null) {
          return filter(this.$store.state.issue_photos, {issue: this.selected_issue.id});
        }
        return [];
      },
      issue_types () {
        return this.$store.state.issue_types;
      },
      store () {
        return this.$store.getters.store;
      },
    },
    methods: {
      floorplan_clicked (event) {
        let {x, y} = event_to_relative(event);
        this.marker_clicked({
          id: null,
          description: "",
          type: null,
          loc_x: x,
          loc_y: y,
          job: this.job.id
        });
      },
      marker_clicked (issue) {
        this.selected_issue = deep_copy(issue);
        this.issue_modal_open = true;
      },
      async add_issue () {
        if (!this.selected_issue.type) {
          this.$store.commit("add_toast", {
            message: "Please select an issue type before adding the issue.",
            time: 8000,
            type: "danger",
          });
          return;
        }
        let issue = await this.$store.dispatch("new_issue", this.selected_issue);
        await this.upload_image(issue.id);
        this.clear_issue();
      },
      async update_issue () {
        if (!this.selected_issue.type) {
          this.$store.commit("add_toast", {
            message: "Please select an issue type before updating the issue.",
            time: 8000,
            type: "danger",
          });
          return;
        }
        let issue = await this.$store.dispatch("update_issue", this.selected_issue);
        await this.upload_image(issue.id);
        this.clear_issue();
      },
      delete_issue () {
        this.$store.dispatch("delete_issue", this.selected_issue);
        this.clear_issue();
      },
      clear_issue () {
        this.issue_modal_open = false;
        this.selected_issue = null;
        this.upload_progress = [];
      },
      async upload_image (issue_id) {
        if (!this.$refs.image_input || !this.$refs.image_input.files.length) {
          return;
        }
        let promises = [];
        each(this.$refs.image_input.files, (f) => {
          let fd = new FormData();
          fd.append("issue", issue_id);
          fd.append("image", f);
          fd.append("file_name", f.name);
          let progress = {percent: 0, id: Math.random()};
          this.upload_progress.push(progress);

          promises.push(
            this.$http.post("/rest/1.0/log/issue-photos/", fd, {
              progress: (event) => {
                if (event.lengthComputable) {
                  progress.percent = (event.loaded / event.total) * 100;
                }
              }
            })
          );
        });
        try {
          let photos = await Promise.all(promises);
          each(photos, (p) => {
            this.$store.commit("add_issue_photo", p.body);
          });
        } catch (err) {
          let message = "Could not upload the image. Please try again.";
          if (err.body && err.body.image) {
            message = err.body.image.join(" ");
          } else if (err.body && err.body.detail) {
            message = err.body.detail;
          }
          this.$store.commit("add_toast", {
            message: message,
            time: 10000,
            type: "danger",
          });
          throw err;
        }
      },
      delete_photo (photo) {
        this.$store.dispatch("delete_issue_photo", photo);
      },
      urgency () {
        this.$router.push({
          name: "job-urgency",
          params: { job_id: this.job.id }
        });
      }
    },
    watch: {
      job (val) {
        if (val) {
          this.$store.commit("select_store", val.store);
        }
      },
    },
    components: {
      Modal,
      ProgressBar,
    }
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/Logger.vue?2f10ed00